export default __webpack_public_path__ + "static/media/react-js-logo.d9b8d48e.png";